var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVersionRelease(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.694,
    height: 14.083,
    viewBox: "0 0 13.694 14.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.5 -3.3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.5 3.3)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#feac29",
    width: 3.317,
    height: 6.016,
    transform: "translate(0 4.041)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#feac29",
    width: 3.317,
    height: 10.042,
    transform: "translate(4.222 2.02)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#feac29",
    d: "M0,0H5.25V14.083H0Z",
    transform: "translate(8.444 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersionRelease);
export default __webpack_public_path__ + "static/media/versionRelease.c02880c89a5c61a56c9c5f357abae46d.svg";
export { ForwardRef as ReactComponent };